import { http } from '@/plugins/http';
import * as TYPES from './mutation-types';

export const loadMailTo = ({ dispatch }) => {
  dispatch('setFetching', { key: 'loadMailTo', value: true });
  dispatch('setMailTo', null);

  return http
    .get('/vikup/mail-to/')
    .then(data => {
      dispatch('setFetching', { key: 'loadMailTo', value: false });
      dispatch('setMailTo', data.data.email);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadMailTo', value: false });
      return Promise.reject(e);
    });
};

export const loadBrands = ({ dispatch }) => {
  dispatch('setFetching', { key: 'loadBrands', value: true });
  dispatch('setBrands', []);

  return http
    .get('/vikup/brands/')
    .then(data => {
      dispatch('setFetching', { key: 'loadBrands', value: false });
      dispatch('setBrands', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadBrands', value: false });
      return Promise.reject(e);
    });
};

export const loadModels = ({ dispatch }, { brand }) => {
  dispatch('setFetching', { key: 'loadModels', value: true });
  dispatch('setModels', []);

  return http
    .get(`/vikup/models/?brand=${brand || ''}`)
    .then(data => {
      dispatch('setFetching', { key: 'loadModels', value: false });
      dispatch('setModels', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadModels', value: false });
      return Promise.reject(e);
    });
};

export const loadYears = ({ dispatch }, { brand, model }) => {
  dispatch('setFetching', { key: 'loadYears', value: true });
  dispatch('setYears', []);

  return http
    .get(`/vikup/creation-years/?brand=${brand || ''}&model=${model || ''}`)
    .then(data => {
      dispatch('setFetching', { key: 'loadYears', value: false });
      dispatch('setYears', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadYears', value: false });
      return Promise.reject(e);
    });
};

export const loadGenerations = ({ dispatch }, { brand, model, year }) => {
  dispatch('setFetching', { key: 'loadGenerations', value: true });
  dispatch('setGenerations', []);

  return http
    .get(`/vikup/generations/?brand=${brand || ''}&model=${model || ''}&year=${year || ''}`)
    .then(data => {
      dispatch('setFetching', { key: 'loadGenerations', value: false });
      dispatch('setGenerations', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadGenerations', value: false });
      return Promise.reject(e);
    });
};

export const loadBodies = ({ dispatch }, { brand, model, year, generation }) => {
  dispatch('setFetching', { key: 'loadBodies', value: true });
  dispatch('setBodies', []);

  return http
    .get(`/vikup/bodies/?brand=${brand || ''}&model=${model || ''}&year=${year || ''}&generation=${generation || ''}`)
    .then(data => {
      dispatch('setFetching', { key: 'loadBodies', value: false });
      dispatch('setBodies', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadBodies', value: false });
      return Promise.reject(e);
    });
};

export const loadGears = ({ dispatch }, { brand, model, year, generation, body, doors }) => {
  dispatch('setFetching', { key: 'loadGears', value: true });
  dispatch('setGears', []);

  return http
    .get(
      `/vikup/gears/?brand=${brand || ''}&model=${model || ''}&year=${year || ''}&generation=${generation || ''}&body=${body || ''
      }&doors=${doors || ''}`
    )
    .then(data => {
      dispatch('setFetching', { key: 'loadGears', value: false });
      dispatch('setGears', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadGears', value: false });
      return Promise.reject(e);
    });
};

export const loadDrives = ({ dispatch }, { brand, model, year, generation, body, doors }) => {
  dispatch('setFetching', { key: 'loadDrives', value: true });
  dispatch('setDrives', []);

  return http
    .get(
      `/vikup/drives/?brand=${brand || ''}&model=${model || ''}&year=${year || ''}&generation=${generation || ''
      }&body=${body || ''}&doors=${doors || ''}`
    )
    .then(data => {
      dispatch('setFetching', { key: 'loadDrives', value: false });
      dispatch('setDrives', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadDrives', value: false });
      return Promise.reject(e);
    });
};

export const loadEngines = ({ dispatch }, { brand, model, year, generation, body, doors }) => {
  dispatch('setFetching', { key: 'loadEngines', value: true });
  dispatch('setEngines', []);

  return http
    .get(
      `/vikup/engines/?brand=${brand || ''}&model=${model || ''}&year=${year || ''}&generation=${generation || ''
      }&body=${body || ''}&doors=${doors || ''}`
    )
    .then(data => {
      dispatch('setFetching', { key: 'loadEngines', value: false });
      dispatch('setEngines', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadEngines', value: false });
      return Promise.reject(e);
    });
};

export const loadModifications = ({ dispatch }, { brand, model, year, generation }) => {
  dispatch('setFetching', { key: 'loadModifications', value: true });
  dispatch('setModifications', []);

  return http
    .get(
      `/vikup/modifications/?brand=${brand || ''}&model=${model || ''}&year=${year || ''}&generation=${generation || ''
      }`
    )
    .then(data => {
      dispatch('setFetching', { key: 'loadModifications', value: false });
      dispatch('setModifications', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadModifications', value: false });
      return Promise.reject(e);
    });
};

export const loadColors = ({ dispatch }) => {
  dispatch('setFetching', { key: 'loadColors', value: true });
  dispatch('setColors', []);

  return http
    .get('/vikup/colors/')
    .then(data => {
      dispatch('setFetching', { key: 'loadColors', value: false });
      dispatch('setColors', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadColors', value: false });
      return Promise.reject(e);
    });
};

export const loadWheels = ({ dispatch }) => {
  dispatch('setFetching', { key: 'loadWheels', value: true });
  dispatch('setWheels', []);

  return http
    .get('/vikup/wheels/')
    .then(data => {
      dispatch('setFetching', { key: 'loadWheels', value: false });
      dispatch('setWheels', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadWheels', value: false });
      return Promise.reject(e);
    });
};

export const loadStates = ({ dispatch }) => {
  dispatch('setFetching', { key: 'loadStates', value: true });
  dispatch('setStates', []);

  return http
    .get('/vikup/states/')
    .then(data => {
      dispatch('setFetching', { key: 'loadStates', value: false });
      dispatch('setStates', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadStates', value: false });
      return Promise.reject(e);
    });
};

export const loadPts = ({ dispatch }) => {
  dispatch('setFetching', { key: 'loadPts', value: true });
  dispatch('setPts', []);

  return http
    .get('/vikup/pts/')
    .then(data => {
      dispatch('setFetching', { key: 'loadPts', value: false });
      dispatch('setPts', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadPts', value: false });
      return Promise.reject(e);
    });
};

export const loadRegions = ({ dispatch }) => {
  dispatch('setFetching', { key: 'loadRegions', value: true });
  dispatch('setRegions', []);

  return http
    .get('/vikup/regions/')
    .then(data => {
      dispatch('setFetching', { key: 'loadRegions', value: false });
      dispatch('setRegions', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadRegions', value: false });
      return Promise.reject(e);
    });
};

export const loadModification = ({ dispatch }, { vin }) => {
  dispatch('setFetching', { key: 'loadModification', value: true });
  dispatch('setModification', []);

  return http
    .get(`/vikup/modification/?vin=${vin}`)
    .then(data => {
      dispatch('setFetching', { key: 'loadModification', value: false });
      dispatch('setModification', data.data);
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadModification', value: false });
      return Promise.reject(e);
    });
};

export const loadCalcedPrice = (
  { dispatch },
  { vin, brand, model, year, body, doors, gear, drive, engine, volume, power, wheel, generation, region }
) => {
  dispatch('setFetching', { key: 'loadAppraisal', value: true });
  return http
    .get(
      `/vikup/appraisal/?vin=${vin}&brand=${brand}&model=${model}&year=${year}&body=${body}&doors=${doors}&gear=${gear}&drive=${drive}&engine=${engine}&volume=${volume}&power=${power}&wheel=${wheel}&generation=${generation}&region=${region}`
    )
    .then(data => {
      dispatch('setFetching', { key: 'loadAppraisal', value: false });
      return data.data;
    })
    .catch(e => {
      dispatch('setFetching', { key: 'loadAppraisal', value: false });
      return Promise.reject(e);
    });
};

export const sendForm = ({ dispatch }, params) => {
  dispatch('setFetching', { key: 'loadAppraisal', value: true })
  return http
    .post('/vikup/send-form/', params)
    .then(data => {
      dispatch('setFetching', { key: 'loadAppraisal', value: false })
      data.data
    })
    .catch(e => Promise.reject(e));
};

export const sendFormExpress = (_, params) => {
  return http
    .post('/vikup/mainSendForm/', params)
    .then(data => data.data)
    .catch(e => Promise.reject(e));
};

export const setFetching = ({ commit }, value) => commit(TYPES.SET_FETCHING, value);
export const setMailTo = ({ commit }, value) => commit(TYPES.SET_MAIL_TO, value);
export const setBrands = ({ commit }, value) => commit(TYPES.SET_BRANDS, value);
export const setModels = ({ commit }, value) => commit(TYPES.SET_MODELS, value);
export const setYears = ({ commit }, value) => commit(TYPES.SET_YEARS, value);
export const setGenerations = ({ commit }, value) => commit(TYPES.SET_GENERATIONS, value);
export const setBodies = ({ commit }, value) => commit(TYPES.SET_BODIES, value);
export const setGears = ({ commit }, value) => commit(TYPES.SET_GEARS, value);
export const setDrives = ({ commit }, value) => commit(TYPES.SET_DRIVES, value);
export const setEngines = ({ commit }, value) => commit(TYPES.SET_ENGINES, value);
export const setModifications = ({ commit }, value) => commit(TYPES.SET_MODIFICATIONS, value);
export const setColors = ({ commit }, value) => commit(TYPES.SET_COLORS, value);
export const setWheels = ({ commit }, value) => commit(TYPES.SET_WHEELS, value);
export const setPts = ({ commit }, value) => commit(TYPES.SET_PTS, value);
export const setStates = ({ commit }, value) => commit(TYPES.SET_STATES, value);
export const setRegions = ({ commit }, value) => commit(TYPES.SET_REGIONS, value);
export const setModification = ({ commit }, value) => commit(TYPES.SET_MODIFICATION, value);
